window.PXUTheme = window.PXUTheme || {};
window.PXUTheme.jsFeaturedPromos = {
  init: function ($section) {
    $section.find('[data-featured-promotions-slider]').each(function () {
      const $promoSlider = $(this);
      const $sectionRoot = $promoSlider.closest('.section');
      const $prevButton = $sectionRoot.find('.featured-promotions__nav--prev');
      const $nextButton = $sectionRoot.find('.featured-promotions__nav--next');

      const $featuredPromosSlider = $promoSlider.flickity({
        initialIndex: 0,
        contain: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        draggable: true
      });

      $featuredPromosSlider.on('settle.flickity', function () {
        $featuredPromosSlider.flickity('resize');
      });

      $prevButton.on('click', function () {
        $featuredPromosSlider.flickity('previous');
      });

      $nextButton.on('click', function () {
        $featuredPromosSlider.flickity('next');
      });

      // Store instance for later use
      $promoSlider.data('flickityInstance', $featuredPromosSlider);
    });
  },

  blockSelect: function ($section, blockId) {
    const $block = $('#shopify-section-' + blockId);
    const $slider = $block.closest('[data-featured-promotions-slider]').data('flickityInstance');

    if ($slider) {
      const slideIndex = $block.data('promo-index');
      $slider.flickity('select', slideIndex, true, true);
    }
  },

  unload: function ($section) {
    $section.find('[data-featured-promotions-slider]').each(function () {
      const $slider = $(this).data('flickityInstance');
      if ($slider) {
        $slider.flickity('destroy');
      }
    });

    $section.find('.featured-promotions__nav--prev').off();
    $section.find('.featured-promotions__nav--next').off();
  }
};
